import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./index.css";
import { AuthGate } from "./shell/AuthGate";

const rootElement = globalThis.document.getElementById("root");

if (!rootElement) {
  throw new Error("Missing root element.");
}

const root = createRoot(rootElement);
const takeoffGridProofEnabled =
  import.meta.env.VITE_TAKEOFF_GRID_PROOF === "1" &&
  globalThis.location.pathname === "/__e2e__/takeoff-grid-proof";

if (takeoffGridProofEnabled) {
  void import("./testing/TakeoffGridProof").then(({ TakeoffGridProof }) =>
    root.render(<TakeoffGridProof />)
  );
} else {
  root.render(
    <AuthGate>
      <App />
    </AuthGate>
  );
}
